import React, { useContext } from 'react';
import Cookies from 'js-cookie';
import UserProvider from '../../context/UserContext';

const NavBarKey = () => {
    const Data = useContext(UserProvider.context);
    const userData = Data.user;

    const id = userData.id;
    const avatar = userData.avatar;
    let avatarUrl = ''
    
    if(avatar == null) {
        avatarUrl = 'https://cdn.discordapp.com/embed/avatars/4.png'
    }
    else {
        avatarUrl = 'https://cdn.discordapp.com/avatars/'+id+'/'+avatar+'.png'
    }
    
    return(
        <nav className="navbar navbar-default">
            <div className="navbar-header navbar-user avatar">
                <img alt="" src={avatarUrl}></img>
                <span>{userData && userData.username ? userData.username.toLowerCase() : ""}#{userData.discriminator}</span>
            </div>
            <div className="navbar-right">
                <div className="logout">
                <button className="logout-button-key" onClick={() => {
                        Cookies.remove('user_data', { path: '/', domain: '.infinitbot.com' })
                        Cookies.remove('session', { path: '/', domain: '.infinitbot.com' })
                        window.location.replace('/')
                    }}>
                    <h4 className="logout-text">Logout</h4>
                </button>
                </div>
            </div>
        </nav>
    )
};

export default NavBarKey;